const PACKAGE_NAME = 'Personalized-content-package';
const RECOMMENDATIONS_CONTEXT = 'recommendation';
const PERSONALIZED_CONTENT_IMPRESSIONS = 'personalized_content';
const GUEST_ID = -1;

const COMPONENT_TYPES = {
    GIGS: {
        GIGS_CAROUSEL_TYPE: 'gigs_sliding_carousel',
        PRO_GIGS_CAROUSEL_TYPE: 'pro_gigs_sliding_carousel',
        GIGS_LISTING_TYPE: 'gigs_listing',
        GIGS_VIEW_LISTING_TYPE: 'gigs_list_view',
        PRO_GIGS_VIEW_LISTING_TYPE: 'pro_gigs_list_view',
        SMALL_GIGS_LIST_VIEW_TYPE: 'gigs_small_list_view',
        PRO_CAROUSEL: 'pro_recommendations_by_sc',
        RECENTLY_VIEWED_TYPE: 'mini_recently_viewed_carousel',
        CHOCOLATE_CAROUSEL_TYPE: 'chocolate_carousel',
        CHOCOLATE_GRID_TYPE: 'chocolate_grid',
        BRICKS_LIST_TYPE: 'bricks_list',
        DYNAMIC_CAROUSEL_TYPE: 'dynamic_gigs_sliding_carousel',
    },
    SELLERS: {
        SELLERS_SLIDING_CAROUSEL_TYPE: 'sellers_sliding_carousel',
        SELLERS_GRID_VIEW_TYPE: 'sellers_grid_view',
        SELLERS_SLIDING_JP_TYPE: 'jp_sliding_carousel',
        SELECTABLE_SELLERS_COLUMN_VIEW_TYPE: 'selectable_sellers_column_view',
        SELLERS_JP_ADAPTIVE_SLIDING_CAROUSEL_TYPE: 'jp_adaptive_sliding_carousel',
    },
    NESTED: {
        CHOICE_TABS: 'gigs_multi_tab',
    },
    ROLES: {
        SELLER_ROLES_SLIDING_CAROUSEL_TYPE: 'seller_roles_sliding_carousel',
    },
    TRANSPARENT_CAROUSEL: 'transparent_carousel',
};

const ALGORITHMS_TYPES = [
    {
        name: 'recently_ordered',
        type: 'buy_it_again',
    },
];

const ENV = {
    DEVELOPMENT: 'development',
};

const ROUTE_CSR_FETCH_FULL_CONTENT = {
    pathfinderKey: 'recommendations_csr_fetch_personalized_content',
    fallbackUrl: '/recommendations/csr_fetch_personalized_content',
};

const ROUTE_CLEAR_RECENTLY_VIEWED_GIGS = {
    pathfinderKey: 'clear_recently_viewed_gigs',
    fallbackUrl: '/recommendations/recently_viewed/gigs',
};

const ROUTE_RECENTLY_VIEWED_PAGE = {
    pathfinderKey: 'generic_recommendations_page',
    config: {
        page_name: 'recently_viewed_page',
    },
    fallbackUrl: '/recommendations/pages/recently_viewed_page',
};

const ROUTE_CLEAR_RECENTLY_VIEWED_GIG = {
    pathfinderKey: 'delete_recently_viewed_gigs',
    config: {
        page_name: 'recently_viewed_page',
    },
    fallbackUrl: '/recommendations/recently_viewed/gigs',
};

const LOGS_KEY = 'personalized_content_package_error_context';

const CAROUSEL_NAMES = {
    RECENTLY_BOUGHT: 'recently_bought',
};

const BADGE_TYPES = {
    BUY_IT_AGAIN: 'buy_it_again',
};

module.exports = {
    PACKAGE_NAME,
    ALGORITHMS_TYPES,
    RECOMMENDATIONS_CONTEXT,
    GUEST_ID,
    ENV,
    PERSONALIZED_CONTENT_IMPRESSIONS,
    COMPONENT_TYPES,
    GIGS_CAROUSEL_TYPE: COMPONENT_TYPES.GIGS.GIGS_CAROUSEL_TYPE,
    PRO_GIGS_CAROUSEL_TYPE: COMPONENT_TYPES.GIGS.PRO_GIGS_CAROUSEL_TYPE,
    GIGS_LISTING_TYPE: COMPONENT_TYPES.GIGS.GIGS_LISTING_TYPE,
    GIGS_VIEW_LISTING_TYPE: COMPONENT_TYPES.GIGS.GIGS_VIEW_LISTING_TYPE,
    SMALL_GIGS_LIST_VIEW_TYPE: COMPONENT_TYPES.GIGS.SMALL_GIGS_LIST_VIEW_TYPE,
    RECENTLY_VIEWED_TYPE: COMPONENT_TYPES.GIGS.RECENTLY_VIEWED_TYPE,
    PRO_GIGS_VIEW_LISTING_TYPE: COMPONENT_TYPES.GIGS.PRO_GIGS_VIEW_LISTING_TYPE,
    PRO_CAROUSEL: COMPONENT_TYPES.GIGS.PRO_CAROUSEL,
    CHOCOLATE_CAROUSEL_TYPE: COMPONENT_TYPES.GIGS.CHOCOLATE_CAROUSEL_TYPE,
    CHOCOLATE_GRID_TYPE: COMPONENT_TYPES.GIGS.CHOCOLATE_GRID_TYPE,
    BRICKS_LIST_TYPE: COMPONENT_TYPES.GIGS.BRICKS_LIST_TYPE,
    DYNAMIC_CAROUSEL_TYPE: COMPONENT_TYPES.GIGS.DYNAMIC_CAROUSEL_TYPE,
    SELLERS_SLIDING_CAROUSEL_TYPE: COMPONENT_TYPES.SELLERS.SELLERS_SLIDING_CAROUSEL_TYPE,
    SELLERS_GRID_VIEW_TYPE: COMPONENT_TYPES.SELLERS.SELLERS_GRID_VIEW_TYPE,
    ROUTE_CSR_FETCH_FULL_CONTENT,
    ROUTE_CLEAR_RECENTLY_VIEWED_GIGS,
    ROUTE_CLEAR_RECENTLY_VIEWED_GIG,
    ROUTE_RECENTLY_VIEWED_PAGE,
    LOGS_KEY,
    CHOICE_NESTED_TABS: COMPONENT_TYPES.NESTED.CHOICE_TABS,
    SELLER_ROLES_SLIDING_CAROUSEL_TYPE: COMPONENT_TYPES.ROLES.SELLER_ROLES_SLIDING_CAROUSEL_TYPE,
    TRANSPARENT_CAROUSEL_TYPE: COMPONENT_TYPES.TRANSPARENT_CAROUSEL,
    CAROUSEL_NAMES,
    BADGE_TYPES,
    SELLERS_SLIDING_JP_TYPE: COMPONENT_TYPES.SELLERS.SELLERS_SLIDING_JP_TYPE,
    SELLERS_JP_ADAPTIVE_SLIDING_CAROUSEL_TYPE: COMPONENT_TYPES.SELLERS.SELLERS_JP_ADAPTIVE_SLIDING_CAROUSEL_TYPE,
};
